<app-header></app-header>

<div
  class="container"
  style="height: auto; margin: 3.5rem auto; max-width: 800px"
>
  <h1 class="mb-3 text-heading">Type your new password</h1>
  <form
    [formGroup]="enterNewPassword"
    #form="ngForm"
    (keydown.enter)="changePassword()"
  >
    <mat-form-field
      [style.width.%]="100"
      appearance="outline"
      style="padding-bottom: 0px"
    >
      <mat-label style="color: #0e0e0e">New Password</mat-label>
      <input
        matInput
        [type]="hide ? 'password' : 'text'"
        formControlName="newPassword"
      />
      <button mat-icon-button matSuffix (click)="hide = !hide" type="button">
        <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
      </button>
    </mat-form-field>
    <div *ngIf="enterNewPassword.get('newPassword').errors">
      <div
        class="text text-danger mb-2"
        *ngIf="
          enterNewPassword.get('newPassword').touched &&
          enterNewPassword.get('newPassword').errors.required
        "
      >
        Password is required.
      </div>
      <div
        class="text text-danger mb-2"
        *ngIf="enterNewPassword.get('newPassword').errors.minlength"
      >
        Password must be at least 8 characters
      </div>
    </div>
    <mat-form-field
      [style.width.%]="100"
      appearance="outline"
      class=""
      style="padding-bottom: 0px"
    >
      <mat-label style="color: #0e0e0e">Re-Type New Password</mat-label>

      <input
        matInput
        [type]="hideConfirmation ? 'password' : 'text'"
        formControlName="confirmPassword"
      />
      <button
        mat-icon-button
        matSuffix
        (click)="hideConfirmation = !hideConfirmation"
        [attr.aria-label]="'hideConfirmation confirmPassword'"
        [attr.aria-pressed]="hideConfirmation"
        type="button"
      >
        <mat-icon>{{
          hideConfirmation ? "visibility_off" : "visibility"
        }}</mat-icon>
      </button>
    </mat-form-field>
    <div *ngIf="enterNewPassword.get('confirmPassword').errors">
      <div
        class="text text-danger mb-2"
        *ngIf="
          enterNewPassword.get('confirmPassword').touched &&
          enterNewPassword.get('confirmPassword').errors.required
        "
      >
        Re-type password is required.
      </div>
      <div
        class="text text-danger mb-2"
        *ngIf="enterNewPassword.get('confirmPassword').errors.minlength"
      >
        Re-type password must be at least 8 characters
      </div>
      <div
      class="text text-danger mb-2"
      *ngIf="
        enterNewPassword.get('newPassword').value.length >= 8 &&
        enterNewPassword.get('confirmPassword').value.length >= 8 &&
        enterNewPassword.get('confirmPassword')!.errors
          .ConfirmPasswordValidator
      "
    >
      Passwords did not match. Try again.
    </div>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="text-white mb-3"
      [style.width.%]="100"
      [disabled]="isDisabled"
      type="button"
      (click)="changePassword()"
    >
      Reset Password
    </button>

    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  </form>
</div>

<app-footer></app-footer>
